import { render, staticRenderFns } from "./HistoricoLog.vue?vue&type=template&id=69c93e92&"
import script from "./HistoricoLog.vue?vue&type=script&lang=js&"
export * from "./HistoricoLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports